import {useRef} from 'react';
import type {ThesaurusId, ThesaurusMap} from 'services/thesaurus/types';
import {getTrimmedThesaurus} from '../functions';

/**
 * Remove all deactivated nodes, unless currently selected (i.e. part of value)
 */
export const useTrimmedThesaurusMap = (
  fullThesauruses: ThesaurusMap,
): ThesaurusMap => {
  const trimmedThesaurusRef = useRef(
    (Object.keys(fullThesauruses) as ThesaurusId[]).reduce<ThesaurusMap>(
      (acc, id) => ({
        ...acc,
        [id]: getTrimmedThesaurus(fullThesauruses[id]!),
      }),
      {},
    ),
  );
  return trimmedThesaurusRef.current;
};
